export default [
    {
        path: '/travellers',
        name: 'travellers',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Users/Travellers.vue')
    }
]